import "./TrackProgressBar.css";

const TrackProgressBar = () => {
  return (
    <div className="track-progress-bar">
      <div className="track-progress-fill" />
    </div>
  );
};

export default TrackProgressBar;
